(function() {
	'use strict';

	angular
		.module('app.setup')
		.service('supplierAllowedColumnService', supplierAllowedColumnService);

	supplierAllowedColumnService.$inject = ['$http', 'URLS'];

	function supplierAllowedColumnService($http, URLS) {
		var baseUrl = URLS.host + String.format(URLS.supplierAllowedColumns, globalConfig.customer.id);
		var service = {
			getSupplierAllowedColumns: getSupplierAllowedColumns,
			saveSupplierAllowedColumns: saveSupplierAllowedColumns
		};
		return service;

		function getSupplierAllowedColumns() {
			return $http.get(baseUrl)
				.then(getSupplierPortalComponentsSuccess, handleError);

			function getSupplierPortalComponentsSuccess(response) {
				return response.data;
			}
		}

		function saveSupplierAllowedColumns(supplierColumns) {
			var allowedColumn = [];
			angular.forEach(supplierColumns, function (column) {
				allowedColumn.push({
					columnId: column
				});
			});
			return $http.post(baseUrl, allowedColumn)
				.then(saveSupplierAllowedColumnsSuccess, handleError);

			function saveSupplierAllowedColumnsSuccess(response) {
				return response.data;
			}
		}

		function handleError (error) {
			if (error.status === 403) {
				return '';
			} else if (error.status === 412) {
				return error.data.error;
			}
			return 'Unknown server error';
		}
	}
})();
